import * as React from 'react';
import { type VariantProps, cva } from 'class-variance-authority';
import { Label as LabelPrimitive } from 'radix-ui';
import { cn } from '@/lib/utils';

export enum LabelVariants {
  DEFAULT = 'default',
  INSPECTOR_SECTION = 'inspector-section',
}

const labelVariants = cva('', {
  variants: {
    variant: {
      [LabelVariants.DEFAULT]:
        'text-base leading-none font-bold peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      [LabelVariants.INSPECTOR_SECTION]:
        'mb-1 text-[10px] font-bold tracking-tighter text-text-gray-alternate uppercase',
    },
  },
  defaultVariants: {
    variant: LabelVariants.DEFAULT,
  },
});

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ variant, className }))} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label, labelVariants };
